(function () {
  var logPrefix = '[LoyaltyLion Auto Discount]';
  console.log('[LoyaltyLion Auto Discount] VERSION ajax-cart-discount-v6');
  var maxWaitMs = 15000;
  var startedAt = Date.now();
  var hookRegistered = false;
  var openCartFlagKey = 'll_open_cart_after_discount';
  var claimedCode = '';
  var redirecting = false;
  var flagLifetimeMs = 120000;

  function log(message, data) {
    if (data !== undefined) console.log(logPrefix, message, data);
    else console.log(logPrefix, message);
  }

  function warn(message, data) {
    if (data !== undefined) console.warn(logPrefix, message, data);
    else console.warn(logPrefix, message);
  }

  function getReturnUrl() {
    var url = new URL(window.location.href);
    url.searchParams.set('ll_open_cart', '1');
    return url.pathname + url.search + url.hash;
  }

  function redirectWithDiscount(code) {
    if (redirecting) return;
    redirecting = true;
    var returnUrl = getReturnUrl();

    try {
      sessionStorage.setItem(openCartFlagKey, String(Date.now()));
    } catch (error) {
      warn('Could not write open cart flag to sessionStorage.', error);
    }

    var discountUrl =
      '/discount/' +
      encodeURIComponent(code) +
      '?redirect=' +
      encodeURIComponent(returnUrl);

    log('Redirecting to Shopify discount URL', discountUrl);
    window.location.href = discountUrl;
  }

  function applyDiscountWithoutNavigation(code) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 3500);

    return fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code }),
      signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Shopify cart update returned ' + response.status);
      return response.json();
    }).then(function (cart) {
      log('Reward discount was sent to the Shopify cart without a page reload.');
      return cart;
    }).finally(function () {
      window.clearTimeout(timeout);
    });
  }

  function closeAliaPopup() {
    var popup = document.querySelector('[aria-label="Promotional popup"], [id^="alia-root-"]');
    if (!popup) return false;

    var closeButton = popup.querySelector('button[aria-label="Close popup"]');
    if (!closeButton) return false;

    log('Closing promotional popup so the reward cart is visible.');
    closeButton.click();
    return true;
  }

  function keepCartVisible() {
    var checks = 0;
    var timer = window.setInterval(function () {
      closeAliaPopup();
      checks += 1;
      if (checks >= 40) window.clearInterval(timer);
    }, 500);
  }

  function isCartOpen() {
    return Boolean(
      document.querySelector('.lcu.lcu_open .lcu__drawer--active') ||
      document.querySelector('cart-drawer.active')
    );
  }

  function openLcuCart() {
    var attempts = 0;
    var maxAttempts = 20;

    function tryOpen() {
      closeAliaPopup();

      if (isCartOpen()) {
        log('Cart is open. Clearing redirect flags.');
        clearOpenCartFlags();
        keepCartVisible();
        return;
      }

      attempts += 1;
      var trigger = document.querySelector('#cart-icon-bubble, .header__icon--cart');

      if (trigger) {
        log('Opening cart via the existing cart trigger.', trigger);
        trigger.dispatchEvent(
          new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
      }

      if (attempts < maxAttempts) {
        window.setTimeout(tryOpen, 1000);
      } else {
        warn('Cart did not open after retries; keeping redirect flag for another page load.');
      }
    }

    tryOpen();
  }

  function shouldOpenCartAfterRedirect() {
    var url = new URL(window.location.href);
    var hasUrlFlag = url.searchParams.get('ll_open_cart') === '1';
    var hasStorageFlag = false;

    try {
      var storedAt = Number(sessionStorage.getItem(openCartFlagKey));
      hasStorageFlag = storedAt > 0 && Date.now() - storedAt < flagLifetimeMs;
      if (storedAt && !hasStorageFlag) sessionStorage.removeItem(openCartFlagKey);
    } catch (error) {
      warn('Could not read open cart flag from sessionStorage.', error);
    }

    log('Checking open cart after redirect.', {
      hasUrlFlag: hasUrlFlag,
      hasStorageFlag: hasStorageFlag,
      currentUrl: window.location.href
    });

    return hasUrlFlag || hasStorageFlag;
  }

  function clearOpenCartFlags() {
    var url = new URL(window.location.href);

    if (url.searchParams.get('ll_open_cart') === '1') {
      url.searchParams.delete('ll_open_cart');
      window.history.replaceState(window.history.state, document.title, url.pathname + url.search + url.hash);
    }

    try {
      sessionStorage.removeItem(openCartFlagKey);
    } catch (error) {
      warn('Could not clear open cart flag from sessionStorage.', error);
    }
  }

  function openCartAfterDiscountRedirect() {
    if (!shouldOpenCartAfterRedirect()) return;

    log('Will attempt to open LCU smart cart after discount redirect.');
    window.setTimeout(openLcuCart, 2500);
  }

  function registerHookOnce() {
    if (hookRegistered) return;

    if (!window.loyaltylion || typeof window.loyaltylion.registerHook !== 'function') {
      return;
    }

    try {
      window.loyaltylion.registerHook(
        'customers.rewards.claimed',
        function ({ claimedReward }) {
          claimedCode =
            claimedReward &&
            claimedReward.redeemable &&
            claimedReward.redeemable.code || '';
          log('Reward claimed.', { hasCode: Boolean(claimedCode) });
          if (!claimedCode) return Promise.resolve({ action: 'show_claim_modal' });

          return applyDiscountWithoutNavigation(claimedCode).then(function () {
            window.setTimeout(openLcuCart, 100);
            return { action: 'hide_claim_modal' };
          }).catch(function (error) {
            warn('Cart discount update failed; showing LoyaltyLion claim modal.', error);
            return { action: 'show_claim_modal' };
          });
        }
      );
      hookRegistered = true;
      log('Registered customers.rewards.claimed hook.');
    } catch (error) {
      warn('Could not register customers.rewards.claimed hook.', error);
    }
  }

  function extractRewardCode(container) {
    if (!container) return '';

    var candidates = [container];
    var codeElements = container.querySelectorAll(
      'input, textarea, [class*="code"], [data-code], [data-discount-code], [data-clipboard-text]'
    );
    for (var i = 0; i < codeElements.length; i++) candidates.push(codeElements[i]);

    for (var j = 0; j < candidates.length; j++) {
      var element = candidates[j];
      var values = [
        element.value,
        element.getAttribute && element.getAttribute('value'),
        element.getAttribute && element.getAttribute('data-code'),
        element.getAttribute && element.getAttribute('data-discount-code'),
        element.getAttribute && element.getAttribute('data-clipboard-text'),
        element.textContent
      ];

      for (var k = 0; k < values.length; k++) {
        var match = typeof values[k] === 'string' && values[k].match(/\bLL[-–—][A-Z0-9-]{5,}\b/i);
        if (match) return match[0].replace(/[–—]/g, '-');
      }
    }

    return '';
  }

  function closeClaimModal(modal, lionRoot) {
    var container = modal || lionRoot;
    var closeButton = container && container.querySelector(
      'button[aria-label*="Close"], button[title*="Close"], .lion-modal__close, .lion-modal__close-button'
    );
    if (!closeButton) return false;
    closeButton.click();
    return true;
  }

  function onLoyaltyLionContinue(event) {
    var button = event.target && event.target.closest && event.target.closest('button, a');
    if (!button || button.textContent.trim().toLowerCase() !== 'continue') return;

    var modal = button.closest('[role="dialog"], .lion-modal, [class*="lion-claimed-reward"]');
    var lionRoot = button.closest('#loyaltylion, .loyaltylion');
    if (!modal && !lionRoot) return;
    if (!/voucher|discount|reward/i.test((modal && modal.textContent || '') + (lionRoot && lionRoot.textContent || ''))) return;

    var code = claimedCode || extractRewardCode(modal) || extractRewardCode(lionRoot);

    if (code) {
      event.preventDefault();
      event.stopImmediatePropagation();
      log('Continue clicked; applying reward discount without reloading.');
      applyDiscountWithoutNavigation(code).then(function () {
        if (!closeClaimModal(modal, lionRoot)) {
          warn('Could not close LoyaltyLion claim modal; using discount redirect.');
          redirectWithDiscount(code);
          return;
        }
        window.setTimeout(openLcuCart, 100);
      }).catch(function (error) {
        warn('Cart discount update failed; using Shopify discount redirect.', error);
        redirectWithDiscount(code);
      });
    } else {
      try {
        sessionStorage.setItem(openCartFlagKey, String(Date.now()));
      } catch (error) {
        warn('Could not save cart flag before LoyaltyLion navigation.', error);
      }
      warn('Continue clicked without a readable code; using LoyaltyLion navigation and opening the cart on return.');
      window.setTimeout(function () {
        if (shouldOpenCartAfterRedirect()) openLcuCart();
      }, 2500);
    }
  }

  function waitForLoyaltyLion() {
    if (!window.loyaltylion || typeof window.loyaltylion.on !== 'function') {
      if (Date.now() - startedAt >= maxWaitMs) {
        warn('LoyaltyLion SDK was not found after waiting.');
        return;
      }

      window.setTimeout(waitForLoyaltyLion, 250);
      return;
    }

    log('LoyaltyLion SDK found.');

    window.loyaltylion.on('ready', registerHookOnce);
  }

  log('Script loaded.');
  document.addEventListener('click', onLoyaltyLionContinue, true);
  openCartAfterDiscountRedirect();
  waitForLoyaltyLion();
})();
